import imgGlasses from '../../../assets/ImagesSuggestions/img-glasses.png';
import imgCamera from '../../../assets/ImagesSuggestions/img-camera.png';
import imgBoyCheck from '../../../assets/ImagesSuggestions/img-boy-check.png';
import imgLight from '../../../assets/ImagesSuggestions/img-light.png';
import imgArrow from '../../../assets/ImagesSuggestions/img-right-arrow.png';
import imgBoy from '../../../assets/ImagesSuggestions/img-boy.png';
import imgGirl from '../../../assets/ImagesSuggestions/img-girl.png';
import imgLightCheck from '../../../assets/ImagesSuggestions/img-light-check.png';
import imgGirlCheck from '../../../assets/ImagesSuggestions/img-girl-check.png';

import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const SelfieSuggestions = () => {

    const { t } = useTranslation();

    const topSuggestions = [
        { img: imgGlasses, textKey: 'no_glasses_or_accessories' },
        { img: imgCamera, textKey: 'look_straight_at_camera' },
        { img: imgBoyCheck, textKey: 'face_fill_frame' },
        { img: imgLight, textKey: 'no_direct_light_or_flash' },
    ];

    const bottomSuggestions = [
        { img: imgBoy, textKey: 'stay_still' },
        { img: imgGirl, textKey: 'neutral_expression' },
        { img: imgLightCheck, textKey: 'proper_lighting' },
        { img: imgGirlCheck, textKey: 'plain_background' },
    ];

    return (
        <div className='selfie-background'>
            <div className='selfie-suggestions-container'>
                {/* Top suggestions */}
                <div className='selfie-suggestions-section'>
                    {topSuggestions.map(({ img, textKey }, idx) => (
                        <div className='selfie-suggestion-item' key={`top-${idx}`}>
                            <img className='selfie-suggestion-icon' src={img} alt='icon' />
                            <p className='selfie-suggestion-text'>{t(textKey)}</p>
                        </div>
                    ))}
                </div>
                {/* Divider with numbers */}
                <div className='divider-container'>
                    <svg className='custom-svg' viewBox='0 0 2150 200'>
                        <line
                            x1='0'
                            x2='100%'
                            y1='100'
                            y2='100'
                            stroke='#006594'
                            strokeWidth='20'
                            strokeLinecap='round'
                            strokeDasharray='1, 40'
                        />
                    </svg>

                    <span className='arrow-container'>
                        <img src={imgArrow} alt='arrow' />
                    </span>

                    <div className='numbers-container'>
                        <span></span>
                        <span>2</span>
                        <span>4</span>
                        <span>6</span>
                        <span>8</span>
                    </div>

                    <div className='numbers-container-bottom'>
                        <span>1</span>
                        <span>3</span>
                        <span>5</span>
                        <span>7</span>
                    </div>
                </div>

                {/* Bottom suggestions */}
                <div className='selfie-suggestions-section'>
                    {bottomSuggestions.map(({ img, textKey }, idx) => (
                        <div className='selfie-suggestion-item' key={`bottom-${idx}`}>
                            <img className='selfie-suggestion-icon' src={img} alt='icon' />
                            <p className='selfie-suggestion-text'>{t(textKey)}</p>
                        </div>
                    ))}
                </div>

            </div>
        </div>
    );
};
export default SelfieSuggestions;
